import { render, staticRenderFns } from "./EventAdd.vue?vue&type=template&id=bb36a958&"
import script from "./EventAdd.vue?vue&type=script&lang=js&"
export * from "./EventAdd.vue?vue&type=script&lang=js&"
import style0 from "./EventAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports